import 'mapbox-gl/dist/mapbox-gl.css';
import { FC } from 'react';
import ReactMapboxGl from 'react-mapbox-gl';
import { Props } from 'react-mapbox-gl/lib/map';
import styled from 'styled-components';

const Wrapper = styled.div`
  position: relative;
  width: var(--width);
  height: var(--height);
  background: none;
`;

const ReactMap = ReactMapboxGl({
  accessToken:
    process.env.NEXT_PUBLIC_MAPBOX_ACCESS_TOKEN ||
    process.env.STORYBOOK_MAPBOX_ACCESS_TOKEN ||
    '',
});

export interface MapProps extends Omit<Props, 'style'> {
  onClick?: any;
}

const Map: FC<MapProps> = ({ children, ...props }) => {
  return (
    <Wrapper>
      <ReactMap
        // eslint-disable-next-line react/style-prop-object
        style='mapbox://styles/salonstudios/cklvq74ms1ckj17o055wkcy9a'
        containerStyle={{
          width: '100%',
          height: '100%',
        }}
        fitBoundsOptions={{ padding: 64 }}
        {...props}
      >
        <>{children}</>
      </ReactMap>
    </Wrapper>
  );
};

export default Map;
